import { Volume2, VolumeX } from "lucide-react";
import { sound, useMuted } from "@/lib/sound";

export function SoundToggle() {
  const muted = useMuted();
  const toggle = () => {
    sound.setMuted(!muted);
    if (muted) sound.meow();
  };
  return (
    <button className="btn-soft h-10 w-10 grid place-items-center shrink-0" onClick={toggle}
      aria-label={muted ? "Turn sounds on" : "Mute sounds"} data-testid="sound-toggle-button" data-muted={muted}>
      {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
    </button>
  );
}
